import { createUniqueFieldSchema } from '@ts-react/form'
import { z } from 'zod'

export const RichTextAreaSchema = createUniqueFieldSchema(z.string(), 'richTextArea')
